<template>
    <div>
        <h4 class="title text-user-secondary">Day {{phase + 1}} Tasks</h4>
        <ul>
            <user-task v-for="task in tasks" v-bind:task="task" v-bind:key="task.event_id"></user-task>

        </ul>
        <hr>
    </div>
</template>

<script>
    import Task from './Task.vue'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            'user-task': Task
        },
        props: ['tasks', 'phase'],
        mounted() {

        },
        computed: {
        },
        data: function () {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style scoped lang="scss">
ul {
    list-style: none;
    padding-left: 0;
}
</style>
